import globalMoment from "../GlobalMoment";

/**
 * BookingSelect.js contains handlers for each step
 * @see all Booking mixins
 * @see CreateLesson.vue manipulates form object and assignment
 */
export default {
    mixins: [globalMoment],
    methods: {
        $_select_location(location) {
            this.nextStep();
        },
        $_select_capacity(capacity) {},
        $_select_offSiteLocation(offSiteLocation) {},
        $_select_occurrences(occurrences) {},
        /*$_select_registrationOnly(registrationOnly) {
            this.nextStep();
        },*/
        async $_select_eventType(type) {
            await this.$_apis_getApiGroupEvents(type);
            this.nextStep();
        },
        /**
         * If ever tempted, do not copy purchaseOption from this event, as it might be inactive.
         * Get user's current active PO instead
         * @param {object} event
         */
        $_select_credit(event) {
            const purchaseOption = this.$_data_getAutoPurchaseOption(
                event,
                event.student,
                this.form.assessmentType
            );

            // This is a hack to make sure the credit reschedule_minutes gets passed into $_select_somethingNew()
            if (event.reschedule_minutes && event.reschedule_minutes < 30) {
                event.duration = event.reschedule_minutes;
            }

            const formData = {
                //duration: null,
                purchaseOption: purchaseOption,
                billingUser:
                    this.$_data_getAutoBillingUser(
                        event.student,
                        purchaseOption
                    ) ?? null,
                type: event.type,
                //substitutePass: !!event.groupEvent?.can_exchange_passes,
            };

            if (event.group_event) {
                if (event.group_event.can_exchange_passes) {
                    this.$_options_clientSubstitutePassSteps(event, formData);
                } else {
                    this.$_options_clientRescheduleClassSteps(event, formData);
                }
            }
            if (!event.group_event) {
                this.$_options_clientSomethingNewSteps(
                    event,
                    formData,
                    {},
                    this.stepNumber
                );
            }

            this.nextStep();
        },
        $_select_class(event) {
            let formData = {
                event_title: event.group_event.title,
                eventType: event.group_event.event_type,
                //repeating: false,
                online: event.online,
                teacher: event.teacher,
                startDate: this.globalMomentUTCDate(event.starts_at),
                startTime: this.globalMomentTime2(event.starts_at),
                location: event.location,
                room: event.room,
                duration: event.duration,
            };

            let componentData = {
                assignment: event.assignment,
                availability: event.availability,
            };

            this.$_controls_setStepData(formData, componentData);

            this.showBookingOutsideLocationAlert();

            this.nextStep();
        },
        $_select_templateEvent(event) {
            let formData = {
                repeating: event.recurring,
                online: event.in_studio_only ? false : null,
                duration: event.set_duration,
                occurrences: event.occurrences ? event.occurrences : false,
            };

            if (event.registration_event) {
                if (this.bookingSource.isCalendar) {
                    this.$_options_calendarRegistrationEventSteps(
                        event,
                        formData
                    );
                } else {
                    this.$_options_newRegistrationEventSteps(event, formData);
                }
            } else {
                this.$_options_templateEventSteps(event, formData);
            }

            //this.$_options_newTemplateEventSteps(event, formData);

            //this.$_controls_setStepData(formData);
            this.showRequiresAssignmentAlert();
            this.nextStep();
        },
        async $_select_student(student) {
            let lessonType = this.form.type;
            // Must wait on apiCancelledLessons for getPurchaseOptions to work for reschedules
            await this.$_apis_getCancelledLessons(
                this.form.type?.reschedule,
                student
            );

            if (this.bookingSource.isSelfServe && this.form.type?.reschedule) {
                if (
                    !this.apiCancelledLessons["totalMinutes"] &&
                    !this.apiCancelledLessons["totalPasses"]
                ) {
                    this.showNoRescheduleAlert(student);
                }
            }

            //this.$_studentService_handle(student);

            let overrideType = null;

            // attempt to find matching credit
            // will only work for reschedule/weekly lessons
            let credit = null;
            if (this.$page.props.staffView) {
                credit = this.$_data_getAutoCredit();
            }

            if (credit) overrideType = credit.type;

            // use credit or type to find matching PO
            const purchaseOption = this.$_data_getAutoPurchaseOption(
                credit ?? { type: lessonType } ?? this.event,
                student,
                this.form.assessmentType
                //this.apiCancelledLessons?.lessons
            );

            if (purchaseOption?.access?.includes("Assessment")) {
                this.form.duration = purchaseOption.duration || 30;
            }

            this.showUnpaidAlert(purchaseOption);

            if (this.$_data_lessonStart && purchaseOption && student) {
                // check if booking past membership end
                let bookingPastMembershipEnd = purchaseOption.ends_at
                    ? moment(new Date(purchaseOption.ends_at)).isBefore(
                          moment(new Date(this.$_data_lessonStart))
                      )
                    : false;

                if (bookingPastMembershipEnd) {
                    this.showBookingPastMembershipEndAlert();
                }
            }

            // if PO returns a cancelled lesson, set credit
            if (
                !credit &&
                this.form.type?.reschedule &&
                (!purchaseOption?.access || this.$page.props.staffView)
            ) {
                credit = this.$_data_getAutoCancelledLesson(purchaseOption);

                overrideType =
                    credit?.type?.name !== this.form.type?.name
                        ? credit?.type
                        : this.form.type;

                //console.log(overrideType);
            }

            let billingUser =
                purchaseOption?.user ??
                this.$_data_getAutoBillingUser(student, purchaseOption) ??
                null;

            const formData = {
                billingUser: billingUser,
                purchaseOption: purchaseOption,
                credit: credit ?? null,
                duration:
                    this.form.duration ?? purchaseOption?.duration ?? null,
                substitutePass: !!credit?.group_event?.can_exchange_passes,
            };

            if (overrideType) {
                formData.type = overrideType;
                formData.assessmentType = this.$_data_getAutoAssessmentType({
                    type: overrideType,
                });
            }

            if (purchaseOption && !this.bookingSource.isSelfServe) {
                //console.log(formData, lessonType);
                // if PO needs to be selected, this will throw an error, so avoid
                this.$_data_checkRescheduleValues(
                    overrideType ?? lessonType,
                    this.form.duration ?? purchaseOption?.duration
                );
            }

            if (this.bookingSource.isSelfServe) {
                if (credit && purchaseOption) {
                    this.$_options_clientSomethingNewSteps(
                        lessonType,
                        formData,
                        {},
                        this.stepNumber
                    );
                } else if (purchaseOption && !this.form.type?.reschedule) {
                    this.$_options_clientRescheduleLessonSteps(
                        lessonType,
                        formData,
                        {},
                        this.stepNumber
                    );
                }
            } else {
                this.$_controls_setStepData(formData);
            }

            this.nextStep();
        },
        $_select_billingUser(billingUser) {
            this.nextStep();
        },
        /*$_select_email(email) {
            this.nextStep();
        },*/
        $_select_purchaseOption(purchaseOption) {
            let consumesPasses = ["Assessment", "Drop-In", "Event"].includes(
                purchaseOption.access
            );

            let duration = null;
            if (this.$page.props.staffView) {
                duration = consumesPasses
                    ? purchaseOption.duration
                    : this.form.duration;
            } else {
                duration = purchaseOption.duration;
            }

            let formData = {
                duration: duration,
                //location: purchaseOption.location,
                //repeating: false,
                assessmentType: this.$_data_getAutoAssessmentType({
                    duration: purchaseOption.duration,
                }),
                credit: this.$_data_getAutoCancelledLesson(purchaseOption),
                billingUser: purchaseOption?.user,
                substitutePass: purchaseOption.is_event,
            };

            let overrideType =
                formData.credit?.type?.name !== this.form.type?.name
                    ? formData.credit?.type
                    : this.form.type;

            if (overrideType) formData.type = overrideType;

            this.$_data_checkRescheduleValues(
                overrideType ?? this.form.type,
                duration
            );

            if (!this.$page.props.staffView) {
                this.$_options_clientRescheduleLessonSteps(
                    this.form.type,
                    formData
                );
            } else {
                this.$_controls_setStepData(formData);
            }
            this.nextStep();
        },
        $_select_instrument(instrument) {
            //this.$_apis_getTeacherAssignments();
            this.nextStep();
        },
        $_select_teacher(teacher) {
            /*if (this.form.registrationOnly) {
                return this.nextStep();
            }*/
            //this.$_apis_getTeacherAssignments();
            if (this.event?.assignment) {
                if (this.event.assignment.user_id == teacher.id) {
                    this.assignment = this.event.assignment;
                    this.availability = this.event.assignment?.availability;
                }
            } else {
                this.availability = this.event?.availabilities?.find((e) => {
                    return e.user_id == teacher.id;
                });
            }

            /**
             * @see this.$_apis_getTeacherConflicts()
             * this is fine, but unavailable teachers should be filtered out before sending to front end
             * it doesn't necessarily matter though because 90% use case won't have this issue
             * because teacher is most often selected prior to date/time.
             * only covers click directly on calendar outside of assignment
             * @see calendarBooking issue
             * booking from instrument view struggles to find avail/assignment because clickData doesn't know the teacher OR the room
             * I can easily add argument to check if the schedule is in instrument view, and then find matching assignment here just by time and teacher
             *
             */
            this.$_apis_getTeacherConflicts();
            this.showTeacherAvailableNotAssignedAlert();
            this.showTeacherUnavailableAlert();
            this.nextStep();
        },
        $_select_online(online) {
            this.showRequiresAssignmentAlert();
            this.nextStep();
        },
        $_select_type(type) {
            let formData = {
                location: this.$page.props.auth.user.selected_location,
                teacher: this.$_data_getAutoTeacher(),
                online: this.$_data_getAutoOnline(this.event),
                repeating: type.recurring,
                type: type,
            };

            if (type.hold) {
                this.$_options_newHoldSteps(type, formData);
            } else if (type.event) {
                this.$_options_groupEventSteps(type, formData, {}, 1);
            } else {
                this.$_options_newLessonSteps(type, formData);
            }
            //this.$_controls_setStepData(formData);

            this.showRequiresAssignmentAlert();
            this.nextStep();
        },
        $_select_repeating(repeating) {
            this.showRecurrenceEndAlert();
            this.nextStep();
        },
        $_select_duration(duration) {
            this.nextStep();
        },
        async $_select_startDate(date, pause) {
            /*if (!this.form.teacher) {
                await this.$_apis_getAssignments();
            } else {*/
            // check if booking past membership end
            let bookingPastMembershipEnd = this.form.purchaseOption?.ends_at
                ? moment(new Date(this.form.purchaseOption.ends_at)).isBefore(
                      moment(new Date(date))
                  )
                : false;

            if (bookingPastMembershipEnd) {
                this.showBookingPastMembershipEndAlert();
                return;
            }

            await this.$_apis_getAssignmentOpenings();
            //}
            if (!pause) this.nextStep();
        },
        $_select_startTime(event) {
            let assignment = event.assignment;
            if (this.event) {
                this.event.assignment = assignment;
            }

            let formData = {
                room: assignment.room,
            };

            let componentData = {
                assignment: assignment,
                availability: assignment?.availability,
            };

            this.$_controls_setStepData(formData, componentData);

            if (this.bookingSource.isGuestSession) return;

            this.showRecurrenceEndAlert();
            this.nextStep();
        },
        $_select_clientInfo(info) {},
        $_select_room(room) {
            if (
                room.registration_room &&
                this.form.templateEvent?.registration_event
            ) {
                this.$_options_newRegistrationOffsiteSteps();
            } else {
                this.$_options_newRegistrationOnsiteSteps();
            }

            this.nextStep();
        },
        $_select_experience(experience) {},
        $_select_somethingNew(somethingNew, event) {
            let formData = {};
            let componentData = {};

            // This will allow clients to reschedule shorter classes for longer duration memberships
            if (somethingNew && event.duration <= 30) {
                formData = {
                    duration: event.duration,
                };
            }
            if (!somethingNew) {
                formData = {
                    duration: event.duration,
                    instrument: event.instrument,
                    location: event.location,
                    teacher: event.teacher,
                };
            }

            this.$_options_clientRescheduleLessonSteps(event, formData);

            this.nextStep();
        },
        $_select_substitutePass(subForLesson, event) {
            let formData = {};

            if (subForLesson) {
                formData = {
                    duration: 30,
                    repeating: false,
                    type: {
                        name: "Reschedule",
                        reschedule: true,
                        disabled: false,
                        originalType: "Event",
                        recurring: false,
                    },
                };
                this.$_options_clientRescheduleLessonSteps(event, formData);
            }
            if (!subForLesson) {
                this.$_options_clientRescheduleClassSteps(event);
            }

            this.nextStep();
        },
        $_select_assessmentType(type) {
            let formData = {
                duration: type.apl ? 15 : 30,
                instrument: this.form.instrument ?? type.instrument ?? null,
                templateEvent: type.event ?? null,
            };

            //this.$_options_newLessonSteps(type, formData);
            this.$_controls_setStepData(formData);

            this.nextStep();
        },
    },
};
